import { message, Select } from "antd";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallV2 } from "hooks";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { SearchIcon } from "icons";
import styles from "./styles.module.scss";
import { useCurrentUserContext } from "providers";

export const UpdateCaseUser = ({
  refetchCases,
  setOpenEmployeesDropdown,
  openEmployeesDropdown,
  employees,
  caseId,
}) => {
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();
  const [
    updateCaseUser,
    {
      data: updateCaseUserData,
      isLoading: updateCaseUserLoading,
      error: updateCaseUserErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_case_user",
    method: "POST",
  });

  async function handleSelect(value, data, case_id) {
    try {
      const res = await updateCaseUser({
        params: { case_id, newUser: value, loggedUser: user?.email },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        refetchCases();
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setOpenEmployeesDropdown(false);
    }
  }

  return (
    <ConditionalRenderer condition={openEmployeesDropdown}>
      <div className={styles.dropdownWrapper}>
        <Select
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          open
          showSearch
          allowClear
          filterOption={(
            input,
            option, // 👈 filter logic
          ) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          suffixIcon={null}
          style={{
            width: "100%",
            height: "40px",
          }}
          placeholder={translator("Search")}
          onChange={(value, data) => handleSelect(value, data, caseId)}
          options={employees}
        />
      </div>
    </ConditionalRenderer>
  );
};
